import store from "@/store";
import axios from "axios";
store.subscribe((mutation) => {
  //   we can set axios headers and local storage from here
  switch (mutation.type) {
    case "auth/SET_TOKEN":
      if (mutation.payload) {
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${mutation.payload}`;
        // storing token in browser's local storage
        localStorage.setItem("token", mutation.payload);
      } else {
        axios.defaults.headers.common["Authorization"] = null;
        // if no item from payload, remove the token
        localStorage.removeItem("token", mutation.payload);
      }
      break;
  }
});

// URLs to exclude from the status indicator (noisy background requests)
const excludedUrls = ["/api/auth/attempt"];

function getRequestPath(config) {
  let url = config.url || "";
  // Strip the baseURL prefix to show just the path
  if (config.baseURL && url.startsWith(config.baseURL)) {
    url = url.slice(config.baseURL.length);
  }
  // Strip query params for cleaner display
  const queryIndex = url.indexOf("?");
  if (queryIndex !== -1) {
    url = url.slice(0, queryIndex);
  }
  return url;
}

// Axios request interceptor — track every outgoing request
axios.interceptors.request.use(
  (config) => {
    const url = getRequestPath(config);
    const isExcluded = excludedUrls.some((excluded) => url.includes(excluded));
    if (!isExcluded) {
      config._httpStatusTracked = true;
      config._httpStatusStartTime = Date.now();
      store.dispatch("http_status/startRequest", {
        url: url,
        method: (config.method || "get").toUpperCase(),
        startTime: config._httpStatusStartTime,
      });
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Axios response interceptor — mark request as completed
axios.interceptors.response.use(
  (response) => {
    if (response.config && response.config._httpStatusTracked) {
      const duration =
        (Date.now() - response.config._httpStatusStartTime) / 1000;
      store.dispatch("http_status/finishRequest", {
        success: true,
        duration: duration,
        errorMessage: null,
      });
    }
    return response;
  },
  (error) => {
    if (error.config && error.config._httpStatusTracked) {
      const duration = (Date.now() - error.config._httpStatusStartTime) / 1000;
      let errorMessage = "Network Connection Problem";
      if (error.response) {
        errorMessage = `Error ${error.response.status}: ${error.response.statusText}`;
      } else if (error.message) {
        errorMessage = error.message;
      }
      store.dispatch("http_status/finishRequest", {
        success: false,
        duration: duration,
        errorMessage: errorMessage,
      });
    }
    return Promise.reject(error);
  }
);
